import {
  INewReportRoles,
  IReportSent,
  IReportType,
  IReportUnid,
} from "../../module/constants";

export const actionTypes = {
  GET_REPORTS: "GET_REPORTS",
  GET_REPORTS_SUCCESS: "GET_REPORTS_SUCCESS",
  GET_REPORTS_FAILURE: "GET_REPORTS_FAILURE",
  DELETE_REPORT: "DELETE_REPORT",
  DELETE_REPORT_SUCCESS: "DELETE_REPORT_SUCCESS",
  DELETE_REPORT_FAILURE: "DELETE_REPORT_FAILURE",
  SET_TO_EDIT: "SET_TO_EDIT",
  SET_IS_EDIT: "SET_IS_EDIT",
  SET_TO_VIEW: "SET_TO_VIEW",

  REPORT_VALUE: "REPORT_VALUE",
  ADD_REPORT_INPUT: "ADD_REPORT_INPUT",
  POST_GENERATE: "POST_GENERATE",
  POST_GENERATE_FAILURE: "POST_GENERATE_SUCCESS",
  POST_GENERATE_SUCCESS: "POST_GENERATE_FAILURE",

  GET_ROLES: "GET_ROLES",
  GET_ROLES_SUCCESS: "GET_ROLES_SUCCESS",
  GET_ROLES_FAILURE: "GET_ROLES_FAILURE",
  GET_REPO_ROLES: "GET_REPO_ROLES",
  GET_REPO_ROLES_SUCCESS: "GET_REPO_ROLES_SUCCESS",
  GET_REPO_ROLES_FAILURE: "GET_REPO_ROLES_FAILURE",
  POST_REPORT: "POST_REPORT",
  POST_REPORT_SUCCESS: "POST_REPORT_SUCCESS",
  POST_REPORT_FAILURE: "POST_REPORT_FAILURE",
  PUT_REPORT: "PUT_REPORT",
  PUT_REPORT_SUCCESS: "PUT_REPORT_SUCCESS",
  PUT_REPORT_FAILURE: "PUT_REPORT_FAILURE",
  PUT_ROLES: "PUT_ROLES",
  PUT_ROLES_SUCCESS: "PUT_ROLES_SUCCESS",
  PUT_ROLES_FAILURE: "PUT_ROLES_FAILURE",
};

export const getReportsAction = () => ({
  type: actionTypes.GET_REPORTS,
});

export const getReportsSuccess = (response: IReportSent[]) => ({
  type: actionTypes.GET_REPORTS_SUCCESS,
  payload: response,
});

export const getReportsFailure = (err: Error) => ({
  type: actionTypes.GET_REPORTS_FAILURE,
  err,
});

export const deleteReportAction = (ids: string[]) => ({
  type: actionTypes.DELETE_REPORT,
  payload: ids,
});

export const deleteReportSuccess = (response: any) => ({
  type: actionTypes.DELETE_REPORT_SUCCESS,
  payload: response,
});

export const deleteReportFailure = (err: Error) => ({
  type: actionTypes.DELETE_REPORT_FAILURE,
  err,
});

export const setToEdit = (data: IReportType) => ({
  type: actionTypes.SET_TO_EDIT,
  payload: data,
});

export const setIsEdit = (b: boolean) => ({
  type: actionTypes.SET_IS_EDIT,
  payload: b,
});

export const setToView = (data: IReportType) => ({
  type: actionTypes.SET_TO_VIEW,
  payload: data,
});

export const reportValue = (payload: any) => ({
  type: actionTypes.REPORT_VALUE,
  payload,
});

export const addReportInput = (payload: any) => ({
  type: actionTypes.ADD_REPORT_INPUT,
  payload,
});

export const postGeneratePreviewAction = (data: any) => ({
  type: actionTypes.POST_GENERATE,
  payload: data,
});

export const postGeneratePreviewSuccess = (response: any) => ({
  type: actionTypes.POST_GENERATE_SUCCESS,
  payload: response,
});

export const postGeneratePreviewFailure = (err: Error) => ({
  type: actionTypes.POST_GENERATE_FAILURE,
  err,
});

export const getRolesAction = () => ({
  type: actionTypes.GET_ROLES,
});

export const getRolesSuccess = (response: any) => ({
  type: actionTypes.GET_ROLES_SUCCESS,
  payload: response.roles,
});

export const getRolesFailure = (err: Error) => ({
  type: actionTypes.GET_ROLES_FAILURE,
  err,
});

export const getRepoRolesAction = (id: string) => ({
  type: actionTypes.GET_REPO_ROLES,
  payload: id,
});

export const getRepoRolesSuccess = (response: any) => ({
  type: actionTypes.GET_REPO_ROLES_SUCCESS,
  payload: response,
});

export const getRepoRolesFailure = (err: Error) => ({
  type: actionTypes.GET_REPO_ROLES_FAILURE,
  err,
});

export const postReportAction = (data: INewReportRoles) => ({
  type: actionTypes.POST_REPORT,
  payload: data,
});

export const postReportSuccess = (response: any) => ({
  type: actionTypes.POST_REPORT_SUCCESS,
  payload: response,
});

export const postReportFailure = (err: Error) => ({
  type: actionTypes.POST_REPORT_FAILURE,
  err,
});

export const putReportAction = (data: IReportUnid, id: string) => ({
  type: actionTypes.PUT_REPORT,
  payload: { data, id },
});

export const putReportSuccess = (response: any) => ({
  type: actionTypes.PUT_REPORT_SUCCESS,
  payload: response,
});

export const putReportFailure = (err: Error) => ({
  type: actionTypes.PUT_REPORT_FAILURE,
  err,
});

export const putRolesAction = (id: string, roles: string[]) => ({
  type: actionTypes.PUT_ROLES,
  payload: { id, roles },
});

export const putRolesSuccess = (response: any) => ({
  type: actionTypes.PUT_ROLES_SUCCESS,
  payload: response,
});

export const putRolesFailure = (err: Error) => ({
  type: actionTypes.PUT_ROLES_FAILURE,
  err,
});
